import cx from 'classnames';

import Tooltip from 'components/common/tooltip/tooltip';
import InfoIcon from 'components/icons/InfoIcon';
import { Input } from 'components/common/form/input';

import { numeric } from 'utils';
import { TokenProjectType } from 'types';

import { StyledInput } from './retire-table.style';

const InputBalance = ({
  selected = [],
  handleChange,
  row
}: {
  selected?: TokenProjectType[];
  handleChange?: (project_id: string, value: string) => void;
  row?: TokenProjectType;
}) => {
  const { project_id, value, error } =
    selected.length > 0
      ? selected.find((p) => p.project_id === row.project_id)
      : row;

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, maxLength } = e.target;
    if (maxLength && value.length > maxLength) {
      return false;
    }
    if (value.startsWith('.') && value.length > 1 && !value.includes('..')) {
      const formattedValue = '0' + value;
      handleChange(project_id, formattedValue);
      return;
    }

    if (numeric(value)) {
      handleChange(project_id, value);
    }
  };

  return (
    <StyledInput>
      <Input
        variant="small"
        type="text"
        placeholder="0"
        inputMode="decimal"
        maxLength={18}
        className={cx({
          'is--error': error !== ''
        })}
        value={value}
        onChange={onChangeHandler}
      />
      {error !== '' && (
        <Tooltip message={error} type="error">
          <InfoIcon />
        </Tooltip>
      )}
    </StyledInput>
  );
};

export default InputBalance;

